module.exports = __webpack_public_path__ + "img/platform-icon.1997ffbc.png";